<template>
  <el-dialog :visible.sync="updateBrandSeriesDialog" width="30%" title="设置系列组" class="addBrand" @close='onClose'>
    <el-form :model="queryParams" :rules="queryParamsRules" ref="queryParamsRefs" label-width="120px" :inline="true">
      <el-form-item label="系列组别称：" prop="serialGroupId">
        <el-select
          v-model="queryParams.serialGroupId"
          filterable
          allow-create
          default-first-option
          value-key="id"
          placeholder="请选择文章标签">
          <el-option
            v-for="item in serialGroupList"
            :key="item.id"
            :label="item.bgName"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onSubmit" type="primary">确 定</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
// queryAllSeriesGroup,
import {

  updateSeriesGroup
} from '@/api/product/productManage'
export default {
  data () {
    return {
      updateBrandSeriesDialog: false,
      serialGroupList: [],
      queryParams: {},
      checkList: [],
      queryParamsRules: {
        serialGroupId: [
          // { required: true, message: '系列组别称不能为空', trigger: 'change' },
          // { required: true, message: '系列组别称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 初始化
    onInitialize (checkList) {
      this.queryParams = { serialGroupId: {} }
      this.checkList = checkList
      this.updateBrandSeriesDialog = true
      this.getQueryAllSeriesGroup()
    },
    // // 获取所有系列组
    // getQueryAllSeriesGroup () {
    //   queryAllSeriesGroup().then(res => {
    //     if (res.data.code === 200) {
    //       this.serialGroupList = res.data.obj
    //     }
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) {
          let id = null
          let name = ''
          if (this.queryParams.serialGroupId.id) {
            id = this.queryParams.serialGroupId.id
            name = this.queryParams.serialGroupId.bgName
          } else {
            name = this.queryParams.serialGroupId
          }
          const params = {
            ids: this.checkList.map(i => i.id).join(','),
            seriesGroupId: id,
            seriesGroupName: name
          }
          updateSeriesGroup(params).then(res => {
            if (res.data.code === 200) {
              this.updateBrandSeriesDialog = false
              this.$emit('onRefresh')
              this.$message.success('设置成功!')
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$message.error('校验未通过')
          return false
        }
      })
    },
    // 取消关闭弹窗
    onClose () {
      this.$refs.queryParamsRefs.clearValidate()// 去掉校验
      this.updateBrandSeriesDialog = false
    }
  }
}
</script>

<style>

</style>
